import TemplateView from '../../../../../../js/TemplateView'
import DateRangeSelector from '../../../../../../js/components/DateRangeSelector'

const TWO_YEARS_RANGE = 365 * 2 + 1

export default class ICalFeedDateRangeSelector extends TemplateView {
    constructor({
        onSelectionChanged,
    }) {
        super()

        this.callbacks = {
            onSelectionChanged,
        }

        this.state = {
            selection: null,
            selectionValid: false,
        }

        this.onAnyStatePropertyDeeplyChanged(['selection', 'selectionValid'], state =>
            this.dateRangeSelector.setState({
                selection: state.selection,
                selectionValid: state.selectionValid,
            }))
    }

    templateHtml() {
        return `<div class='field'>
                    <div class='fieldTitle'>
                        <%=dateRangeSelectorTitle%>
                    </div>
                    <div class='dateRangeSelectorWrapper fieldInput'/>
                </div>`
    }

    messageKeys() {
        return {
            dateRangeSelectorTitle: 'icalendar.page.lightbox.field.date_range'
        }
    }

    afterRender() {
        this.dateRangeSelector = new DateRangeSelector({
            selectorId: 'dateSelector',
            rangeMaxDays: TWO_YEARS_RANGE,
            rangeTooLongMessageKey: 'date_range_selector.range_error.longer_than_2_years',
            menuStates: [
                new window.AT.CurrentMonthMenuItem(),
                new window.AT.CurrentAndNextMonthMenuItem(),
                new window.AT.NextMonthMenuItem(),
                new window.AT.PreviousMonthMenuItem(),
                window.AT.DateRangeSelectorSeparator,
                new window.AT.CurrentYearMenuItem(),
                new window.AT.CurrentAndNextYearMenuItem(),
                new window.AT.NextYearMenuItem(),
                new window.AT.PreviousYearMenuItem(),
                window.AT.DateRangeSelectorSeparator,
                new window.AT.CustomDateRangeMenuItem()
            ],
            onSelectionChanged: this.callbacks.onSelectionChanged,
        }).init(this.find('.dateRangeSelectorWrapper'))
    }
}



// WEBPACK FOOTER //
// ./web/actiplans/js/icalendar/components/lightbox/edit/ICalFeedDateRangeSelector.js